import type { SizeProperty, SizePropertyInput } from '@src/types';
import { execAdmin } from '../utils';

const gql = String.raw;

interface SizePropertyGraphQL {
  id: number;
  code: string;
  display: string;
  synonyms: string[];
  family: string[];
  primaryValue?: string | null;
  primaryLabel?: string | null;
  secondaryValue?: string | null;
  secondaryLabel?: string | null;
  tertiaryValue?: string | null;
  tertiaryLabel?: string | null;
  createdAt: string;
  updatedAt: string;
}

interface UpdateSizePropertyInput {
  code?: string;
  display?: string;
  synonyms?: string[];
  family?: string[];
  primaryValue?: string | null;
  primaryLabel?: string | null;
  secondaryValue?: string | null;
  secondaryLabel?: string | null;
  tertiaryValue?: string | null;
  tertiaryLabel?: string | null;
}

interface UpdateSizePropertyResponse {
  partner: {
    updateSizeProperty: SizePropertyGraphQL;
  };
}

interface UpdateSizePropertyVariables {
  partnerCode: string;
  id: number;
  input: UpdateSizePropertyInput;
}

const UPDATE_SIZE_PROPERTY_MUTATION = gql`
  mutation updateSizeProperty($partnerCode: String!, $id: Int!, $input: SizePropertyUpdateInputTypeAdmin!) {
    partner(code: $partnerCode) {
      updateSizeProperty(id: $id, input: $input) {
        id
        code
        display
        synonyms
        family
        primaryValue
        primaryLabel
        secondaryValue
        secondaryLabel
        tertiaryValue
        tertiaryLabel
        createdAt
        updatedAt
      }
    }
  }
`;

export const updateSizeProperty = async ({
  id,
  partnerCode,
  token,
  data,
}: {
  id: number;
  partnerCode: string;
  token: string;
  data: Partial<SizePropertyInput>;
}): Promise<SizeProperty> => {
  const input: UpdateSizePropertyInput = {
    code: data.code,
    display: data.display,
    synonyms: data.synonyms,
    family: data.family,
    primaryValue: data.primary_value || null,
    primaryLabel: data.primary_label || null,
    secondaryValue: data.secondary_value || null,
    secondaryLabel: data.secondary_label || null,
    tertiaryValue: data.tertiary_value || null,
    tertiaryLabel: data.tertiary_label || null,
  };

  const variables: UpdateSizePropertyVariables = {
    partnerCode,
    id,
    input,
  };

  const response = await execAdmin<UpdateSizePropertyVariables, UpdateSizePropertyResponse>(
    UPDATE_SIZE_PROPERTY_MUTATION,
    { variables }
  );

  const updated = response.partner.updateSizeProperty;

  // Map GraphQL camelCase to frontend snake_case
  return {
    id: updated.id,
    partner_code: partnerCode,
    code: updated.code,
    display: updated.display,
    synonyms: updated.synonyms,
    family: updated.family,
    primary_value: updated.primaryValue,
    primary_label: updated.primaryLabel,
    secondary_value: updated.secondaryValue,
    secondary_label: updated.secondaryLabel,
    tertiary_value: updated.tertiaryValue,
    tertiary_label: updated.tertiaryLabel,
    created_at: updated.createdAt,
    updated_at: updated.updatedAt,
  };
};
